export function getSessionSettingsFromSessionStorage() {
  return (
    sessionStorageGetItem('sessionSettings') &&
    JSON.parse(sessionStorageGetItem('sessionSettings'))
  );
}

export function removeSessionSettingsFromSessionStorage() {
  sessionStorageRemoveItem('sessionSettings');
}

export function removeFusionIdFromSessionStorage() {
  sessionStorageRemoveItem('fusionId');
}

export function storeSessionSettingsInSessionStorage(sessionSettings) {
  sessionStorageSetItem('sessionSettings', JSON.stringify(sessionSettings));
}

export function sessionStorageRemoveItem(key: string) {
  sessionStorage.removeItem(key);
}

export function sessionStorageSetItem(
  key: string,
  value: string,
  objectKey?: string,
) {
  if (objectKey) {
    let currentData = JSON.parse(sessionStorage.getItem(objectKey));
    if (currentData) {
      currentData.key = value;
      sessionStorage.setItem(objectKey, JSON.stringify(currentData));
    }
  } else {
    sessionStorage.setItem(key, value);
  }
}

export function sessionStorageGetItem(key: string) {
  return sessionStorage.getItem(key);
}
